/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { ReferencingObjectDto } from './ReferencingObjectDto';
import {
    ReferencingObjectDtoFromJSON,
    ReferencingObjectDtoFromJSONTyped,
    ReferencingObjectDtoToJSON,
} from './ReferencingObjectDto';
import type { EnumerationQuantityDtoQuantityUsageType } from './EnumerationQuantityDtoQuantityUsageType';
import {
    EnumerationQuantityDtoQuantityUsageTypeFromJSON,
    EnumerationQuantityDtoQuantityUsageTypeFromJSONTyped,
    EnumerationQuantityDtoQuantityUsageTypeToJSON,
} from './EnumerationQuantityDtoQuantityUsageType';
import type { UserCatalogDto } from './UserCatalogDto';
import {
    UserCatalogDtoFromJSON,
    UserCatalogDtoFromJSONTyped,
    UserCatalogDtoToJSON,
} from './UserCatalogDto';
import type { EnumerationQuantityUsageDto } from './EnumerationQuantityUsageDto';
import {
    EnumerationQuantityUsageDtoFromJSON,
    EnumerationQuantityUsageDtoFromJSONTyped,
    EnumerationQuantityUsageDtoToJSON,
} from './EnumerationQuantityUsageDto';
import type { PossibleActionDto } from './PossibleActionDto';
import {
    PossibleActionDtoFromJSON,
    PossibleActionDtoFromJSONTyped,
    PossibleActionDtoToJSON,
} from './PossibleActionDto';
import type { StateOfUse } from './StateOfUse';
import {
    StateOfUseFromJSON,
    StateOfUseFromJSONTyped,
    StateOfUseToJSON,
} from './StateOfUse';
import type { FileMetaInfoDto } from './FileMetaInfoDto';
import {
    FileMetaInfoDtoFromJSON,
    FileMetaInfoDtoFromJSONTyped,
    FileMetaInfoDtoToJSON,
} from './FileMetaInfoDto';
import type { EntityOrigin } from './EntityOrigin';
import {
    EntityOriginFromJSON,
    EntityOriginFromJSONTyped,
    EntityOriginToJSON,
} from './EntityOrigin';
import type { PtwCommentDto } from './PtwCommentDto';
import {
    PtwCommentDtoFromJSON,
    PtwCommentDtoFromJSONTyped,
    PtwCommentDtoToJSON,
} from './PtwCommentDto';

/**
 * 
 * @export
 * @interface EnumerationQuantityDto
 */
export interface EnumerationQuantityDto {
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof EnumerationQuantityDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EnumerationQuantityDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EnumerationQuantityDto
     */
    commentCount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof EnumerationQuantityDto
     */
    commentAttachmentsCount?: number | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    lastComment?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationQuantityDto
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {EntityOrigin}
     * @memberof EnumerationQuantityDto
     */
    origin?: EntityOrigin;
    /**
     * 
     * @type {Array<PossibleActionDto>}
     * @memberof EnumerationQuantityDto
     */
    readonly possibleActions?: Array<PossibleActionDto> | null;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof EnumerationQuantityDto
     */
    creatorUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof EnumerationQuantityDto
     */
    lastModifierUser?: UserCatalogDto;
    /**
     * 
     * @type {UserCatalogDto}
     * @memberof EnumerationQuantityDto
     */
    editingUser?: UserCatalogDto;
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    editingTime?: string | null;
    /**
     * 
     * @type {Array<PtwCommentDto>}
     * @memberof EnumerationQuantityDto
     */
    comments?: Array<PtwCommentDto> | null;
    /**
     * 
     * @type {Array<FileMetaInfoDto>}
     * @memberof EnumerationQuantityDto
     */
    attachments?: Array<FileMetaInfoDto> | null;
    /**
     * 
     * @type {boolean}
     * @memberof EnumerationQuantityDto
     */
    isReferenced?: boolean;
    /**
     * 
     * @type {Array<ReferencingObjectDto>}
     * @memberof EnumerationQuantityDto
     */
    isReferencedBy?: Array<ReferencingObjectDto> | null;
    /**
     * 
     * @type {StateOfUse}
     * @memberof EnumerationQuantityDto
     */
    state?: StateOfUse;
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    iuid?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    description?: string | null;
    /**
     * 
     * @type {EnumerationQuantityDtoQuantityUsageType}
     * @memberof EnumerationQuantityDto
     */
    quantityUsageType?: EnumerationQuantityDtoQuantityUsageType | null;
    /**
     * 
     * @type {EnumerationQuantityUsageDto}
     * @memberof EnumerationQuantityDto
     */
    setupUsage?: EnumerationQuantityUsageDto;
    /**
     * 
     * @type {EnumerationQuantityUsageDto}
     * @memberof EnumerationQuantityDto
     */
    evaluationUsage?: EnumerationQuantityUsageDto;
    /**
     * 
     * @type {string}
     * @memberof EnumerationQuantityDto
     */
    $type?: EnumerationQuantityDtoTypeEnum;
}


/**
 * @export
 */
export const EnumerationQuantityDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoEnumerationDtoEnumerationQuantityDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.EnumerationDto.EnumerationQuantityDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnumerationQuantityDtoTypeEnum = typeof EnumerationQuantityDtoTypeEnum[keyof typeof EnumerationQuantityDtoTypeEnum];



/**
 * Check if a given object implements the EnumerationQuantityDto interface.
 */
export function instanceOfEnumerationQuantityDto(value?: unknown): value is EnumerationQuantityDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationQuantityDtoTypeEnum)[0];
}

export function EnumerationQuantityDtoFromJSON(json: any): EnumerationQuantityDto {
    return EnumerationQuantityDtoFromJSONTyped(json, false);
}

export function EnumerationQuantityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationQuantityDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'commentCount': json['commentCount'] == null ? undefined : json['commentCount'],
        'commentAttachmentsCount': json['commentAttachmentsCount'] == null ? undefined : json['commentAttachmentsCount'],
        'lastComment': json['lastComment'] == null ? undefined : json['lastComment'],
        'isAvailable': json['isAvailable'] == null ? undefined : json['isAvailable'],
        'origin': json['origin'] == null ? undefined : EntityOriginFromJSON(json['origin']),
        'possibleActions': json['possibleActions'] == null ? undefined : ((json['possibleActions'] as Array<any>).map(PossibleActionDtoFromJSON)),
        'creatorUser': json['creatorUser'] == null ? undefined : UserCatalogDtoFromJSON(json['creatorUser']),
        'lastModifierUser': json['lastModifierUser'] == null ? undefined : UserCatalogDtoFromJSON(json['lastModifierUser']),
        'editingUser': json['editingUser'] == null ? undefined : UserCatalogDtoFromJSON(json['editingUser']),
        'editingTime': json['editingTime'] == null ? undefined : json['editingTime'],
        'comments': json['comments'] == null ? undefined : ((json['comments'] as Array<any>).map(PtwCommentDtoFromJSON)),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(FileMetaInfoDtoFromJSON)),
        'isReferenced': json['isReferenced'] == null ? undefined : json['isReferenced'],
        'isReferencedBy': json['isReferencedBy'] == null ? undefined : ((json['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoFromJSON)),
        'state': json['state'] == null ? undefined : StateOfUseFromJSON(json['state']),
        'name': json['name'],
        'iuid': json['iuid'] == null ? undefined : json['iuid'],
        'description': json['description'] == null ? undefined : json['description'],
        'quantityUsageType': json['quantityUsageType'] == null ? undefined : EnumerationQuantityDtoQuantityUsageTypeFromJSON(json['quantityUsageType']),
        'setupUsage': json['setupUsage'] == null ? undefined : EnumerationQuantityUsageDtoFromJSON(json['setupUsage']),
        'evaluationUsage': json['evaluationUsage'] == null ? undefined : EnumerationQuantityUsageDtoFromJSON(json['evaluationUsage']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function EnumerationQuantityDtoToJSON(value?: Omit<EnumerationQuantityDto, 'creationTime'|'creatorUserId'|'lastModifierUserId'|'possibleActions'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'lastModificationTime': value['lastModificationTime'],
        'commentCount': value['commentCount'],
        'commentAttachmentsCount': value['commentAttachmentsCount'],
        'lastComment': value['lastComment'],
        'isAvailable': value['isAvailable'],
        'origin': EntityOriginToJSON(value['origin']),
        'creatorUser': UserCatalogDtoToJSON(value['creatorUser']),
        'lastModifierUser': UserCatalogDtoToJSON(value['lastModifierUser']),
        'editingUser': UserCatalogDtoToJSON(value['editingUser']),
        'editingTime': value['editingTime'],
        'comments': value['comments'] == null ? undefined : ((value['comments'] as Array<any>).map(PtwCommentDtoToJSON)),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(FileMetaInfoDtoToJSON)),
        'isReferenced': value['isReferenced'],
        'isReferencedBy': value['isReferencedBy'] == null ? undefined : ((value['isReferencedBy'] as Array<any>).map(ReferencingObjectDtoToJSON)),
        'state': StateOfUseToJSON(value['state']),
        'name': value['name'],
        'iuid': value['iuid'],
        'description': value['description'],
        'quantityUsageType': EnumerationQuantityDtoQuantityUsageTypeToJSON(value['quantityUsageType']),
        'setupUsage': EnumerationQuantityUsageDtoToJSON(value['setupUsage']),
        'evaluationUsage': EnumerationQuantityUsageDtoToJSON(value['evaluationUsage']),
        '$type': value['$type'],
    });
}

